module.exports = __webpack_public_path__ + "img/livera_box.a2060797.png";